import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import validate from './validate';
import { renderField, renderHidden } from '../../../utils/renderFields';
import { sendNewPlayerAlertRequest } from '../../../actions/auth';
import { fetchHomepageAlerts } from '../../../actions/alerts';

const propTypes = {
  closeModal: PropTypes.func,
};

const defaultProps = {
  closeModal: () => {
  },
};

class SendPlayerAlertForm extends React.Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.afterSuccess = this.afterSuccess.bind(this);
  }

  afterSuccess() {
    const { closeModal, fetchAlerts } = this.props;
    fetchAlerts();
    setTimeout(() => {
      closeModal();
    }, 3000);
  }

  submit(values) {
    const { broadcast } = this.props;
    return broadcast(values, this.afterSuccess);
  }

  render() {
    const { error, handleSubmit, submitting, submitSucceeded, livecamTitle, messageLength } = this.props;
    if (submitSucceeded) {
      return (
        <div className="text-center">
          <p>Player alert sent!</p>
        </div>
      );
    }
    return (
      <div className="p-20">
        <p>To send a player alert for <strong>{livecamTitle}</strong>, fill out the following information.</p>
        <form onSubmit={handleSubmit(this.submit)}>
          <span className="u-fontSize-11">{error}</span>
          <Field
            component={renderField}
            name="message"
            label="Enter the message for the player alert"
            className="form-control"
            maxLength={75}
            groupClasses="mb-0"
          />
          <span className="form-control-sm d-block">{messageLength}/75</span>
          <div className="mb-2 text-secondary"><strong>Starting:</strong> Now</div>
          <Field
            name="duration"
            className="form-control"
            type="number"
            component={renderField}
            label="Duration (in minutes)"
          />
          <Field component={renderHidden} name="token" />
          <input type="submit" value="Submit" className="btn btn-primary" disabled={submitting} />
        </form>
      </div>
    );
  }
}

SendPlayerAlertForm.propTypes = propTypes;
SendPlayerAlertForm.defaultProps = defaultProps;

const SendPlayerAlertFormWrapped = reduxForm({
  form: 'send-player-alert',
  validate,
  fields: ['message', 'livecamId', 'duration'],
  enableReinitialize: true,
})(SendPlayerAlertForm);

const selector = formValueSelector('send-player-alert');

const mapStateToProps = (state, ownProps) => {
  const messageValue = selector(state, 'message');
  return {
    livecamTitle: state.currentItem.data.title,
    livecamId: state.currentItem.data.id,
    closeModal: ownProps.closeModal,
    initialValues: {
      livecamId: state.currentItem.data.id,
      duration: 2,
      message: '',
    },
    messageLength: messageValue ? messageValue.length : 0,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    broadcast: (values, callback) => dispatch(sendNewPlayerAlertRequest(values, callback)),
    fetchAlerts: () => dispatch(fetchHomepageAlerts()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SendPlayerAlertFormWrapped);
